import { render, staticRenderFns } from "./category-hub.vue?vue&type=template&id=ceb09b8e&scoped=true"
import script from "./category-hub.vue?vue&type=script&lang=js"
export * from "./category-hub.vue?vue&type=script&lang=js"
import style0 from "./category-hub.vue?vue&type=style&index=0&id=ceb09b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb09b8e",
  null
  
)

export default component.exports